import { Controller } from "@hotwired/stimulus"

// Auto-submit form controller for search functionality
export default class extends Controller {
  static targets = ["input"]

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300) // Debounce 300ms
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}